import React from "react";
import PropTypes from "prop-types";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { ClickAwayListener } from "@material-ui/core";
import styles from "./styles";

import imageVitalityMegaMenu from "../../../assets/images/fondo_mega_menu_vitality.jpg";
import vitalityLogoMegaMenu from "../../../assets/images/logo_vitality_mega_menu.svg";

export const Vitality = ({ handleClickAway, visible }) => {
  const classes = styles();
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={classes.absoluteSContainer}
        style={{ display: visible ? "flex" : "none" }}
      >
        <div className={classes.mainContainer}>
          <div
            className={`${classes.coberturaEcuadorMegaMenu} ${classes.megaMenuVitalityBackground}`}
            style={{
              backgroundImage: `url(${imageVitalityMegaMenu})`
            }}
          >
            <div className={classes.megaMenuMedicaMundial}>
              <div style={{ maxWidth: "225px" }}>
                <img src={vitalityLogoMegaMenu} alt="vitality_logo_mega_menu" />
                <div
                  className={classes.subtituloContenedorCoberturaMegaMenu}
                  style={{ marginTop: "20px" }}
                >
                  Vitality de Saludsa te premia por cumplir tu metas de
                  actividad física y mejorar tu estado de salud.
                </div>
              </div>
              <div>
                <a
                  href="/vitality/"
                  className={classes.linkPageCoberturaMegaMenu}
                >
                  <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                    ¿Qué es Vitality?
                  </div>
                  <span className={classes.iconoFlechaMegaMenu}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </a>
                <a
                  href="/vitality/premios/#tabAnuales"
                  className={classes.linkPageCoberturaMegaMenu}
                >
                  <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                    ¿Cómo ganar el 20% cashback en tu plan médico?
                  </div>
                  <span className={classes.iconoFlechaMegaMenu}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </a>
                <a
                  href="/vitality/premios/#tabMensuales#"
                  className={classes.linkPageCoberturaMegaMenu}
                >
                  <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                    ¿Cómo ganar el 100% de cashback en un reloj gármin?
                  </div>
                  <span className={classes.iconoFlechaMegaMenu}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </a>
                <a
                  href="/vitality/premios/#tabSemanales"
                  className={classes.linkPageCoberturaMegaMenu}
                >
                  <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                    ¿Cómo ganar premios todas las semanas?
                  </div>
                  <span className={classes.iconoFlechaMegaMenu}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </a>
                <a
                  href="/vitality/se-miembro/"
                  className={classes.linkPageCoberturaMegaMenu}
                >
                  <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                    ¿Cómo registrarme?
                  </div>
                  <span className={classes.iconoFlechaMegaMenu}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </a>
              </div>
              <div>
                <a
                  href="/vitality/#descargar-app"
                  className={classes.botonesCoberturaMegaMenu}
                >
                  Descarga el App
                </a>
                <a
                  href="/vitality/videos-sincronizacion/"
                  className={`${classes.botonesCoberturaMegaMenu} ${classes.megaMenuBotonVitality}`}
                >
                  Tutoriales
                </a>
                <a
                  href="/vitality/ayuda-vitality/"
                  className={`${classes.botonesCoberturaMegaMenu} ${classes.megaMenuBotonVitality}`}
                >
                  Guía de uso
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

Vitality.propTypes = {
  handleClickAway: PropTypes.any,
  visible: PropTypes.any
};
